import { PartialId } from '@attain-apps/string-builder'

import * as core from '../../../../../../../../../core'
import * as previousOccupier from '../previous-occupier'

export const RESOURCE = {
  payload: {
    canBeOptional: true,
    context: core.dms.models.Attribute.Id.Context.from({
      context: previousOccupier.RESOURCE.payload.dimension.partialId,
      partialId: previousOccupier.RESOURCE.payload.partialId,
      type: core.dms.models.Type.Snapshot,
    }),
    description: 'User whose change made the space record lose its occupier',
    isOptional: true,
    name: 'Changed By',
    partialId: PartialId.Standard.create('changed_by'),
    type: core.common.value.types.Intrinsic.Text,
  },
  type: core.quiver.Resource.Type.DmsAttribute,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsAttribute>
